import type { FormInstance } from '@arco-design/web-react';

import type { PipelineContext } from '../../../core/types';
import { MsSpecSchema } from './schema';
import type { MsSpec } from './schema';
import { msFromForm } from './spec';

/**
 * 解析模型订阅预览规格。
 * Arco 的 getFieldsValue 只返回已注册字段，完整 store 才包含跨步骤写入的 customModelID 展示值。
 */
export function resolveMsPreviewSpec(
  form: Pick<FormInstance, 'getFields' | 'getFieldsValue'> | undefined,
  spec: unknown,
  ctx: PipelineContext,
): MsSpec {
  if (spec != null) {
    return MsSpecSchema.parse(spec);
  }

  const formValues = (form?.getFields() ?? form?.getFieldsValue() ?? {}) as Record<string, unknown>;
  return MsSpecSchema.parse(msFromForm(formValues, ctx));
}
